export default "__VITE_ASSET__DxOhZj09__"